<div class="logo">
  <a href="" class="simple-text">
    <div class="logo-img" style=" display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;">
      <img src="/assets/img/angular2-logo-red.png" />
    </div>

    <br>
    <b>Ankara Üniversitesi</b>
  </a>
</div>
<div class="sidebar-wrapper" id="perfect">
  <div *ngIf="isMobileMenu()">
    <form class="navbar-form">
      <span class="bmd-form-group">
        <div class="input-group no-border">
          <input type="text" value="" class="form-control" placeholder="Search...">
          <button mat-raised-button type="submit" class="btn btn-white btn-round btn-just-icon">
            <i class="material-icons">search</i>
            <div class="ripple-container"></div>
          </button>
        </div>
      </span>
    </form>

  </div>
  <ul class="nav">




    <li routerLinkActive="active" *ngFor="let menuItem of menuItems" class="{{menuItem.class}} nav-item"
      [attr.data-target]="'#List-'+(menuItem.path)">

      <a class="nav-link" [routerLink]="[menuItem.path] " [queryParams]="{ version: version }">
        <i class="material-icons">{{menuItem.icon}}</i>
        <p>{{menuItem.name}}</p>
      </a>

      <ul *ngIf="menuItem.subItems != null && menuItem.subItems.length>=1"
        class="{{menuItem.subItems.class}} nav-item  " id="List-{{ menuItem.path }}">
        <a routerLinkActive="active" *ngFor="let submenuItem of menuItem.subItems" class="nav-link "
          [href]="[submenuItem.path]">

          <li>

            <p>{{submenuItem.name}}</p>

          </li>
        </a>
      </ul>
    </li>
    <li class="nav-item">
      <a class="nav-link" href="javascript:void(0)" (click)="logout()">
        <i class="material-icons">person</i>

        <p class="d-md-block">Çıkış</p>

      </a>
    </li>

  </ul>
</div>
